import { render, staticRenderFns } from "./LinkContactDialog.vue?vue&type=template&id=4a70d084"
import script from "./LinkContactDialog.vue?vue&type=script&lang=ts"
export * from "./LinkContactDialog.vue?vue&type=script&lang=ts"
import style0 from "./LinkContactDialog.vue?vue&type=style&index=0&id=4a70d084&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports